import { bannerShow, bannerHide, setTargetingArguments } from 'shared/actions/globals';
import googletag from './googletag';
import { slots } from './store';

let scrollSetTimeout = null;
let blockDisplay = false;
// let blockDisplayAfterScroll = false;
// const heightScrollToShow = 330;

export const defineOutOfPageSlot = {
  ab_mobile_web_catfish: 'div-gpt-ad-1510224093566-0',
};
export const problemSlot = {
  mobile_web_top: 'mobile_web_top',
  ab_branding_top: 'branding_top',
  style: {
    ab_mobile_web_catfish: { id: 'banner' },
    ab_mobile_web_catfish_button: { id: 'close_ab_mobile_web_catfish' },
  },
};
export const problemSlotFunc = () => {
  window.App.dispatch(bannerHide());
  const bannerOne = window.document.getElementById(problemSlot.style.ab_mobile_web_catfish.id);
  if (bannerOne) {
    bannerOne.parentNode.removeChild(bannerOne);
    window.AbStor.blockAbInstallNext = false;
    blockDisplay = false;
    window.AbStor.blockAbInstall = false;
  }
};
export const scrollFun = () => {
  // if (window.scrollY >= heightScrollToShow && blockDisplayAfterScroll === false) {
  //   blockDisplayAfterScroll = true;
  //   // eslint-disable-next-line no-use-before-define
  //   time(0, 1000);
  // }

  const bannerShowWidth = window.innerWidth < window.innerHeight;
  const changeObserver = () => {
    if (!window.AbStor.blockAbInstall && window.document.getElementById('close')) {
      document.querySelector(`#close`).click(() => {
        problemSlotFunc();
      });
      window.document.getElementById('close').onclick = () => {
        problemSlotFunc();
      };
      window.AbStor.blockAbInstall = true;
    }
    if (
      !window.AbStor.blockAbInstallNext &&
      window.document.getElementById(problemSlot.style.ab_mobile_web_catfish_button.id)
    ) {
      document.querySelector(`#${problemSlot.style.ab_mobile_web_catfish_button.id}`).click(() => {
        problemSlotFunc();
      });
      window.document.getElementById(
        problemSlot.style.ab_mobile_web_catfish_button.id,
      ).onclick = () => {
        problemSlotFunc();
      };
      window.AbStor.blockAbInstallNext = true;
    }
  };
  if (!bannerShowWidth) {
    blockDisplay = false;
    clearTimeout(scrollSetTimeout);
    scrollSetTimeout = setTimeout(() => {
      if (document.getElementById(problemSlot.style.ab_mobile_web_catfish.id)) {
        document.getElementById(problemSlot.style.ab_mobile_web_catfish.id).style.display = 'none';
      }
    }, 700);
  } else if (bannerShowWidth && !blockDisplay) {
    clearTimeout(scrollSetTimeout);
    scrollSetTimeout = setTimeout(() => {
      const state = window.App.getState && window.App.getState();
      const { globals: { banner = {} } = {} } = state;
      if (banner.slot_1) {
        const abMobileWebCatfish = window.document.getElementById(
          problemSlot.style.ab_mobile_web_catfish.id,
        );
        const abMobileBodyABIdBlock = window.document.getElementById('bodyABIdBlock');
        const scrollY = window.scrollY;
        const windowHeight = 0; // window.innerHeight;

        if (abMobileWebCatfish && scrollY >= windowHeight) {
          blockDisplay = true;
          abMobileWebCatfish.style.display = 'block';

          const observer = new MutationObserver(changeObserver);
          if (abMobileBodyABIdBlock) {
            observer.observe(abMobileBodyABIdBlock, { attributes: true, childList: true });
          }

          changeObserver();
        }
      }
    }, 700);
  }
};
export const targetingCheck = targeting => {
  let state;

  if (typeof targeting === 'function' && targeting() && targeting().targetingAds) {
    window.App.dispatch(setTargetingArguments(targeting().targetingAds));
    state = { getState: window.App.getState };
  } else {
    state = { getState: window.App.getState };
  }

  if (state && state.getState && typeof state.getState === 'function') {
    const { globals: { targeting: { targetingSlot } = {} } = {} } = state.getState();

    if (targetingSlot) {
      const obj =
        (targetingSlot && Object.keys(targetingSlot)[0] in targetingSlot && targetingSlot) || false;
      return obj;
    }
    return false;
  }

  return false;
};
export const time = (iter, timeout = 300) => {
  if (!typeof window === 'object' || !(typeof window === 'object' && window.googletag)) return;
  const displayArr = Object.keys(window.AbStor.DefineSlot);
  if (
    window.googletag &&
    window.googletag.apiReady &&
    window.AbStor.DefineSlot &&
    window.googletag.pubadsReady &&
    displayArr[0] in window.AbStor.DefineSlot
  ) {
    clearTimeout(window.AbStor.SetTimeoutrefresh);
    window.AbStor.SetTimeoutrefresh = setTimeout(() => {
      const refresh = [];
      Object.keys(window.AbStor.DefineSlot).map(a => {
        if (
          defineOutOfPageSlot.ab_mobile_web_catfish === window.AbStor.adUnitNameId[a] &&
          window.document.getElementById(defineOutOfPageSlot.ab_mobile_web_catfish)
        ) {
          problemSlotFunc();
          window.App.dispatch(bannerShow());
        }
        if (window.document.getElementById(window.AbStor.adUnitNameId[a])) {
          refresh.push(window.AbStor.DefineSlot[a]);
        }
        return '';
      });

      window.googletag.pubads().refresh(refresh);
      displayArr.map(a => {
        if (window.document.getElementById(window.AbStor.adUnitNameId[a])) {
          if (!defineOutOfPageSlot[a]) {
            window.googletag.display(window.AbStor.adUnitNameId[a]);
          }
        }
        return '';
      });
      scrollFun();
    }, timeout);
  } else if (iter < 10 /* 00 */) {
    let buf = iter;
    setTimeout(time, 100 + iter * 1.1, (buf += 1));
  }
};
export const googletagSlotFn = ({ targetingAds, id = '', componentWillUnmount }, render) => {
  if (!id) return { slotId: '' };
  for (let a = 0, b = slots, c = b.length; a < c; a += 1) {
    if (b[a].slotId === id) {
      return render
        ? b[a]
        : googletag({
            componentWillUnmount: componentWillUnmount
              ? [
                  {
                    ...b[a],
                    targetingArguments: targetingAds ? () => ({ targetingAds }) : null,
                  },
                ]
              : false,
            slots: [
              {
                ...b[a],
                targetingArguments: targetingAds ? () => ({ targetingAds }) : null,
              },
            ],
          });
    }
  }
  return { slotId: '' };
};



// WEBPACK FOOTER //
// ./src/shared/modules/googletag/TargetingCheck.js